/**
 * Website "Creative web design process": tab list that collapses to an accordion on tablet/mobile.
 */
document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.creative-web-process-section');
    if (!section) return;

    var items = section.querySelectorAll('.creative-process-tab-item');

    items.forEach(function (item) {
        var btn = item.querySelector('.creative-process-tab-btn');
        var pane = item.querySelector('.creative-process-tab-pane');
        if (!btn) return;

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var isAlreadyActive = item.classList.contains('active');

            items.forEach(function (otherItem) {
                otherItem.classList.remove('active');
                var otherBtn = otherItem.querySelector('.creative-process-tab-btn');
                var otherPane = otherItem.querySelector('.creative-process-tab-pane');
                if (otherBtn) otherBtn.classList.remove('active');
                if (otherPane) otherPane.classList.remove('active');
            });

            // On desktop a tab is always open; on smaller screens clicking it again closes it
            if (!isAlreadyActive || window.innerWidth > 1024) {
                item.classList.add('active');
                btn.classList.add('active');
                if (pane) pane.classList.add('active');
            }
        });
    });
});
